import React from 'react';

const Ticker = () => {
  const styles = {
    container: { background: '#0f172a', color: '#fbbf24', overflow: 'hidden', whiteSpace: 'nowrap', padding: '10px 0', fontSize: '14px', fontWeight: 'bold', letterSpacing: '1px' },
    scrollingText: { display: 'inline-block', animation: 'scroll 25s linear infinite' }
  };
  return (
    <>
      <style>{`@keyframes scroll { 0% { transform: translateX(-100%); } 100% { transform: translateX(100%); } }`}</style>
      <div style={styles.container}>
        <div style={styles.scrollingText}>
          🔓 خدمات تخطي iCloud و Google Account (FRP) مضمونة 100% | 💻 متوفر لابتوبات مستعملة وجديدة (Dell, HP, Lenovo) بأسعار تنافسية | 🔧 خدمات السوفتوير عن بعد (Remote Service) | ⚡ تفعيل سيرفرات وبوكسات
        </div>
      </div>
    </>
  );
};
export default Ticker;